import { sitApi } from './sitApiClient';

export async function startRun(plan, options = {}) {
  const headers = {};
  if (options.idempotencyKey) headers['Idempotency-Key'] = options.idempotencyKey;
  const body = { plan };
  // Importer-generated plans carry diagram refs the reporter embeds in the PDF.
  if (options.diagrams && options.diagrams.length > 0) body.diagrams = options.diagrams;
  const { data } = await sitApi.post('/runs', body, { headers });
  return data;
}

export async function getRun(runId) {
  const { data } = await sitApi.get(`/runs/${encodeURIComponent(runId)}`);
  return data;
}

export async function listRuns() {
  const { data } = await sitApi.get('/runs');
  return data.runs ?? [];
}

/**
 * Troubleshoot aggregator — used by ReportViewer to render the audio player
 * + transcript scrubber + inline per-step reasoning. Returns:
 *   { testRunId, status, recordingUrl, transcriptChunks, report }
 * `recordingUrl` is a short-lived presigned GET (5 min); refetch when it
 * expires. `report` is the slim per-step verdict bundle pulled from the
 * persisted report.json — null while the report hasn't landed yet.
 */
export async function getTroubleshoot(runId) {
  const { data } = await sitApi.get(`/runs/${encodeURIComponent(runId)}/troubleshoot`);
  return data;
}

/**
 * POST /runs/{id}/cancel — flip an in-flight run's status to CANCELLED and
 * Stop the Step Functions execution. Idempotent: cancelling an already
 * terminal run (COMPLETED/FAILED/ERROR/CANCELLED) returns the row unchanged
 * with { changed: false }. In-flight PSTN media continues to completion
 * (Chime doesn't support mid-call abort); further step-function transitions
 * are stopped so the reporter finalizes against whatever transcript
 * accumulated up to that point.
 */
export async function cancelRun(runId) {
  const { data } = await sitApi.post(`/runs/${encodeURIComponent(runId)}/cancel`);
  return data;
}
